export default __webpack_public_path__ + "static/media/policy_ru.49655b65.pdf";